export default "https://npm-assets.fiverrcdn.com/assets/@fiverr/search_perseus/apps/Ebook_Writing_es.1a62c4f.vtt";